import HeroVideoSection from "./sections/HeroVideoSection";
import IntroSplitSection from "./sections/IntroSplitSection";
import SavoirBandSection from "./sections/SavoirBandSection";
import DomainsSection from "./sections/DomainsSection";
import OpeningHoursSection from "./sections/OpeningHoursSection";
import { SavoirHeroSection, ProHeroSection } from "./sections/PageHero";
import TextVideoSection from "./sections/TextVideoSection";
import QuoteBandSection from "./sections/QuoteBandSection";
import GallerySection from "./sections/GallerySection";
import ProIntroSection from "./sections/ProIntroSection";
import ProContactBandSection from "./sections/ProContactBandSection";
import ParticuliersSection from "./sections/ParticuliersSection";
import ContactFormSection from "./sections/ContactFormSection";
import AccessMapSection from "./sections/AccessMapSection";
import LegalContentSection from "./sections/LegalContentSection";
import PrivacyContentSection from "./sections/PrivacyContentSection";
import SiteHeader from "./sections/SiteHeader";
import SiteFooter from "./sections/SiteFooter";
import ContactConfirmationPage from "./pages/ContactConfirmationPage";
// EXCEPTION ASSUMÉE à l'isolation entre moteurs — la même que "agence_v1" :
// /boutique et /panier ne rendent QUE les sections de leur template, ces
// deux composants sont empruntés à l'identique au moteur "default".
import ProductGridSection from "../default/sections/ProductGridSection";
import CheckoutFormSection from "../default/sections/CheckoutFormSection";

// Registre du moteur de thème "couture_v1" — le site vitrine « Couture et
// Retouches » (AEF Retouches, handoff `Couture et Retouches.dc.html`),
// reproduit page par page. Doit rester en phase avec le catalogue serveur du
// MÊME moteur (backend/services/theme_engines/couture_v1/sections.py).
export const SECTION_REGISTRY = {
  hero_video: { label: "Bandeau vidéo", Component: HeroVideoSection },
  intro_split: { label: "Présentation", Component: IntroSplitSection },
  savoir_band: { label: "Bande sombre « savoir-faire »", Component: SavoirBandSection },
  domains: { label: "Domaines d'intervention", Component: DomainsSection },
  opening_hours: { label: "Horaires", Component: OpeningHoursSection },
  savoir_hero: { label: "Bandeau « savoir-faire »", Component: SavoirHeroSection },
  text_video: { label: "Texte et vidéo", Component: TextVideoSection },
  quote_band: { label: "Bande citation", Component: QuoteBandSection },
  gallery: { label: "Galerie de l'atelier", Component: GallerySection },
  pro_hero: { label: "Bandeau « professionnels »", Component: ProHeroSection },
  pro_intro: { label: "Positionnement B2B", Component: ProIntroSection },
  pro_contact_band: { label: "Bande contact sombre", Component: ProContactBandSection },
  particuliers: { label: "Bloc particuliers", Component: ParticuliersSection },
  contact_form: { label: "Formulaire de contact", Component: ContactFormSection },
  access_map: { label: "Plan d'accès", Component: AccessMapSection },
  legal_content: { label: "Mentions légales", Component: LegalContentSection },
  // Page partagée par tous les moteurs (backend theme_engines/shared_pages.py).
  privacy_content: { label: "Politique de confidentialité", Component: PrivacyContentSection },
  product_grid: { label: "Grille de produits", Component: ProductGridSection },
  checkout_form: { label: "Formulaire de commande", Component: CheckoutFormSection },
};

// Couche d'EXTENSION des sections PARTAGÉES (importées des autres moteurs
// sous leur type préfixé — voir themes/shared.js) : pour adapter une section
// importée à la particularité de CE moteur, y déclarer un composant qui
// remplace ou enveloppe celui d'origine, ex. :
//
//   import AgenceHero from "../agence_v1/sections/HeroSection";
//   const HeroPourIci = (p) => <div className="…"><AgenceHero {...p} /></div>;
//   export const SHARED_EXTENSIONS = { agence_hero: { Component: HeroPourIci, label: "…" } };
//
// Le pendant serveur (textes par défaut, champs, pages, libellé) est
// `shared_overrides` du CATALOG du moteur (backend theme_engines/<moteur>/).
export const SHARED_EXTENSIONS = {};

export const DEFAULT_SECTION_ORDER = ["hero_video", "intro_split", "savoir_band", "domains", "opening_hours"];

// En-tête et pied de page rendus par le moteur (voir themes/registry.js).
export const CHROME = {
  Header: SiteHeader,
  Footer: SiteFooter,
  // Hauteur réservée par Layout.jsx avant le premier rendu de l'en-tête
  // (padding 20px × 2 + logotype 28px + 4px + 10px), sur bureau.
  headerHeight: 84,
};

export const PAGES = {
  contact_confirmation: ContactConfirmationPage,
};

// Pages PROPRES au moteur : chemin public → template de sections (miroir de
// PAGES dans backend/services/theme_engines/couture_v1/sections.py). Servies
// par pages/EnginePage.jsx ; `seoKey` est la clé de Gestion SEO, `title` /
// `description` le repli tant que l'admin n'y a rien saisi.
export const ROUTES = {
  "/savoir-faire": {
    template: "savoir_faire",
    seoKey: "savoir-faire",
    title: "Notre savoir-faire",
    description: "Plus de 40 ans dans le métier : retouches, réparations et transformations sur tissus, cuirs et peaux, avec une exigence intacte.",
  },
  "/professionnels-contact": {
    template: "pro_contact",
    seoKey: "professionnels-contact",
    title: "Professionnels & contact",
    description: "L'expertise de la retouche au service des marques et des professionnels de la mode — et des particuliers, sans rendez-vous.",
  },
  "/mentions-legales": {
    template: "legal",
    seoKey: "mentions-legales",
    title: "Mentions légales",
    description: "Informations légales, données personnelles et cookies.",
  },
  // Page PARTAGÉE par tous les moteurs (backend theme_engines/shared_pages.py).
  "/confidentialite": {
    template: "privacy",
    seoKey: "confidentialite",
    title: "Politique de confidentialité",
    description: "Comment nous utilisons vos données de navigation pour améliorer le site.",
  },
};
